module.exports = __webpack_public_path__ + "static/media/password_protection.9010edde.svg";